import { HelpersModule } from "../helpers/helpers";

const helpersModule = new HelpersModule();

export class LocationFinderModule {

    constructor(mapApiCallbacks) {

        this.lat = null;
        this.lng = null;
        this.treatment = null;
        this.location = null;
        this.doctype = "";
        this.show = 3;
        this.default = 3;
        this.showAll = false;
        this.max = 9;
        this.totalRecords = 0;
        this.isMobile = false;
        this.mapApiCallbacks = mapApiCallbacks;

        this.hasSpirgpSetUp = false;  
        this.hasBupaEnabled = false; 
        this.hasBreastClinicEnabled = false; 

        if ($("#SpireGPModule").length > 0) {
            this.hasSpirgpSetUp = ($("#SpireGPModule").val() == 1 ? true : false );
        }

        if ($("#BupaEnabled").length > 0) {
            this.hasBupaEnabled = ($("#BupaEnabled").val() == 1 ? true : false);
        }

        if ($("#BreastClinicEnabled").length > 0) {
            this.hasBreastClinicEnabled = ($("#BreastClinicEnabled").val() == 1 ? true : false);
        }

        if ($(".js-location-finder").length > 0) {
            this.setup();
        }

    }

    scrollTo(name) {
        this.scrollToResolver(document.getElementById(name));
    }

    scrollToResolver(elem) {
        let that = this;
        let offset = 30;
        if (that.isMobileDevice()) {
            offset = 100;
        }
        let jump = parseInt(elem.getBoundingClientRect().top * .2) - offset;
        document.body.scrollTop += jump;
        document.documentElement.scrollTop += jump;
        //lastjump detects anchor unreachable, also manual scrolling to cancel animation if scroll > jump
        if (!elem.lastjump || elem.lastjump > Math.abs(jump)) {
            elem.lastjump = Math.abs(jump);
            setTimeout(function () {
                that.scrollToResolver(elem);
            }, "100");
        } else {
            elem.lastjump = null;
        }
    }

    setup() {

        let that = this;
        let finders = $(".js-location-finder");

        if (finders == undefined || finders.length == 0) return;

        let $body = $("body");

        that.doctype = $body.attr("data-dtype");
        that.groupTreatmentArea = that.doctype === "grouptreatmentarea" ? $body.data("content") : null;
        that.isMobile = that.isMobileDevice();

        if (that.doctype == "grouplocations") {
            that.max = -1;
            that.default = 6;

            if (that.isMobile) {
                that.show = 2;
            }
            else {
                that.show = 6;
            }
        }
        that.setupGoogleApi();
    }

    isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    }

    //filterLocationsForSpireGP(locations) {
    //    var spireGPModule = document.getElementById("SpireGPModule");
    //    if (spireGPModule != null && spireGPModule != "undefined") {

    //        var hasSpirgpSetUp = $("#SpireGPModule").val();
    //        if (hasSpirgpSetUp) {
    //            locations = $.grep(locations, function (el, idx) { return el.SpireGPEnabled }, false);
    //        }
    //    }
    //    return locations;
    //}
    // Filtering bupa enabled hospitals - SW-1888
    //filterLocationsForBupa(locations) {
    //    var hasBupaEnabled = $("#BupaEnabled");
    //    if (hasBupaEnabled != null && hasBupaEnabled != "undefined") {

    //        var hasBupaSetUp = $("#BupaEnabled").val();
    //        if (hasBupaSetUp) {
    //            locations = $.grep(locations, function (el, idx) { return el.BupaEnabledHospital }, false);
    //        }
    //    }
    //    return locations;
    //}

    //filterOneStopBreastClinic(locations) {
    //    var hasBreastClinicEnabled = $("#BreastClinicEnabled");
    //    if (hasBreastClinicEnabled != null && hasBreastClinicEnabled != "undefined") {

    //        var hasBreastClinicSetUp = $("#BreastClinicEnabled").val();
    //        if (hasBreastClinicSetUp == 1) {
    //            locations = $.grep(locations, function (el, idx) { return el.BreastClinicEnabled }, false);
    //        }
    //    }
    //    return locations;
    //}

    getUrlParams() {
        var that = this;
        that.lat = helpersModule.getParameterByName("lat");
        that.lng = helpersModule.getParameterByName("lon");
        that.location = helpersModule.getParameterByName("location");
        if (that.lat != undefined && that.lng != undefined) {
            // set the location in the search box.
            var latlng = { lat: parseFloat(that.lat), lng: parseFloat(that.lng) };
            var geocoder = new google.maps.Geocoder;
            geocoder.geocode({ 'location': latlng }, function (results, status) {
                if (status === 'OK') {
                    if (results[0]) {

                        let address = results[0].formatted_address;
                        const searchInput = $("#location-finder");
                        $(searchInput).val(address);
                        that.lat = latlng.lat;
                        that.lng = latlng.lng;
                        that.locationFinderBindResults(searchInput, false, 3);

                        //that.filterLocationsForSpireGP(that.location);
                        //that.filterLocationsForBupa(that.location);
                        //that.filterOneStopBreastClinic(that.location);

                    } else {
                        console.log("err - No results were found!");
                    }
                } else {
                    console.log("Geocoder failed due to: " + status);
                }
            });
        }
    }

    showMoreClick(searchInput) {
        var that = this
        var componentipc = $(searchInput).parents('[data-c-name]:first');

        if (componentipc != null) {
            $(componentipc).attr('data-show-count', '3');
        }

        $(componentipc).find(".js-finder__hospital-treatment--show-more").off("click");

        $(componentipc).find(".js-finder__hospital-treatment--show-more").on("click", function (e) {
            e.preventDefault();

            let showCount = $(componentipc).data("show-count");

            if (showCount == null) {
                showCount = 3;
                $(componentipc).data("show-count", '3');
            }
            else if (showCount >= 3 && showCount < 6) {
                showCount = 6;
                $(componentipc).data("show-count", '6');
            }
            else {
                showCount = -1;
                $(componentipc).data("show-count", '-1');
            }

            that.locationFinderBindResults(searchInput, false, showCount);

        });
        
    }

    setupGoogleApi() {
        var that = this;
        const finders = $(".js-location-finder");
        const options = {
            componentRestrictions: { 'country': 'gb' },
            types: ['geocode'] // (cities)
        };
        const googleApiUrl = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyALpZboQbieD8FePSqE0JK2LdTvHlnAZy4&libraries=places';


        var selectFirstOnEnter = function (input) {  // store the original event binding function
            var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;
            function addEventListenerWrapper(type, listener) {  // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected, and then trigger the original listener.
                if (type == "keydown") {
                    var orig_listener = listener;
                    listener = function (event) {
                        var suggestion_selected = $(".pac-item-selected").length > 0;
                        if (event.which == 13 && !suggestion_selected) {
                            var simulated_downarrow = $.Event("keydown", { keyCode: 40, which: 40 });
                            orig_listener.apply(input, [simulated_downarrow]);
                        }
                        orig_listener.apply(input, [event]);
                    };
                }
                _addEventListener.apply(input, [type, listener]); // add the modified listener
            }
            if (input.addEventListener) {
                input.addEventListener = addEventListenerWrapper;
            } else if (input.attachEvent) {
                input.attachEvent = addEventListenerWrapper;
            }
        };

        that.mapApiCallbacks.push( function () {

            that.getUrlParams();


            jQuery.each(finders, function (key, value) {
                const searchInput = finders[key];

                const autocomplete = new google.maps.places.Autocomplete(
                    searchInput,
                    options
                );

                let hasDownBeenPressed = false;

                that.showMoreClick(searchInput);

                selectFirstOnEnter(searchInput);

                google.maps.event.addDomListener(searchInput, "keydown", e => {
                    // Maps API e.stopPropagation();
                    e.cancelBubble = true;
                    // If enter key, or tab key
                    //if (e.keyCode === 13 && searchInput.length > 0) {   //|| e.keyCode === 9) {
                    //    // If user isn't navigating using arrows and this hasn't ran yet
                    //    if (!hasDownBeenPressed && !e.hasRanOnce) {
                    //        e.preventDefault();
                    //        google.maps.event.trigger(e.target, "keydown", {
                    //            keyCode: 40,
                    //            hasRanOnce: true
                    //        });
                    //    }
                    //}

                });

                google.maps.event.addListener(autocomplete, "place_changed", function () {
                    var LatLng;
                    // Get the place info from the autocomplete Api
                    const place = autocomplete.getPlace();



                    $(".js-finder__hospital-treatment--error").hide();
                    //If we can find the place lets go to it
                    if (typeof place.address_components !== "undefined") {
                        // reset hasDownBeenPressed in case they don't unfocus
                        hasDownBeenPressed = false;

                        // Get returned location
                        const returnedCoords = new google.maps.LatLng(
                            place.geometry.location.lat(),
                            place.geometry.location.lng()
                        );

                        if (place.geometry.location) {
                            that.lat = place.geometry.location.lat();
                            that.lng = place.geometry.location.lng();
                            that.locationFinderBindResults(searchInput, false, 3);
                        }

                    }
                    else {
                        $(".js-finder__hospital-treatment--error").show();
                    }
                });

            });

        });

    }

    setUrlParamsAndNavigateToDataUrl() {
        let that = this;
        let url = helpersModule.appendTrailingSlash(that.navigationUrl);
        let address = "?lat=" + that.lat + "&lon=" + that.lng;
        window.location.href = url + address;
    }

    redirectToDataUrl(navigationUrl) {
        this.navigationUrl = navigationUrl;
        return this.setUrlParamsAndNavigateToDataUrl(); // Navigate to the calling URL instead of showing the results.
    }

    locationFinderBindResults(searchInput, allowScroll, show) {
        let that = this;
        // using the searchInput control, get closest form and find the data-navigation-url.
        let componentForm = $(searchInput).closest('form');

        // Check we are on a treatment page
        that.treatment = $(document).find('body').data('treatment-id');
        if (that.treatment == undefined) {
            that.treatment = "";
        }

        // if the data-navigation-url exists then change window location.

        let navigationUrl = $(componentForm).data("navigation-url");
        if (navigationUrl != undefined && navigationUrl.length > 0) {
            that.redirectToDataUrl(navigationUrl);
        }
        else {
            let componentipc = $(searchInput).parents('[data-c-name]:first');
            let showResults = $(componentipc).data("show-results");

            if (showResults == undefined)
                showResults = true;

            if (showResults) {
                $(".js-finder__hospital-treatment--error").hide();

                if (that.lat == undefined || that.lng == undefined) {
                    return;
                } else {
                    if (that.lat == null || that.lng == null) {
                        return;
                    }
                    else {
                        if (that.lat == "null" || that.lng == "null") {
                            return;
                        }
                    }
                }
                let addressurl = "";
                let userLatLong = that.lat + ";" + that.lng;
                if (that.lat !== "" && that.lng !== "") {
                    let laturl = "&lat=",
                        lonurl = "&lon=";
                    addressurl = laturl + that.lat + lonurl + that.lng;
                }

                let filterString = "&filterBupa=" + that.hasBupaEnabled + "&filterOneStopBreastClinics=" + that.hasBreastClinicEnabled + "&filterSpireGp=" + that.hasSpirgpSetUp;

                let useHcpUrl = $("#UseHCPUrl").val();
                let specialityId = $("#SpireSpecialityId").val();
                let method = "";
                if (specialityId != "0" && specialityId != "" && specialityId != 'undefined' && specialityId != undefined) {

                    let params = addressurl + "&treatment=" + that.treatment + "&speciality=" + specialityId + filterString;
                    params = params.trim();
                    params = params.replace("&&", "&");
                    params = (params[0] == '&') ? params.substr(1) : params;
                    method = 'CustomApi/GetGroupMapHospitalsBySpecialty/?' + params;
                }
                else {

                    if (useHcpUrl == undefined) {
                        useHcpUrl = 0;
                    }

                    let params = addressurl + "&treatment=" + that.treatment + "&max=" + that.max +
                        (that.groupTreatmentArea ? ("&treatmentAreaId=" + that.groupTreatmentArea) : "") + "&useHcpUrl=" + useHcpUrl + filterString;
                    params = params.trim();
                    params = params.replace("&&", "&");
                    params = (params[0] == '&') ? params.substr(1) : params;

                    method = 'CustomApi/GetGroupMapHospitalsP2/?' + params
                }

                that.callMethod(method, userLatLong, allowScroll, componentipc, show);
            }
            else {
                return;
            }

            

        }


    }

    sortLocationsByDistance(locations, userLatLong) {

        var that = this;

        function sorter(a, b) {
            return a.distance - b.distance;
        }

        var latlong = userLatLong.split(";");

        for (var i = 0; i < locations.length; i++) {
            locations[i].distance = that.calculateDistance(latlong[0], latlong[1], locations[i].lat, locations[i].lon);
            locations[i].distanceFriendly = locations[i].distance.toFixed(2) + " miles";
        }

        locations.sort(sorter);

        return locations;

    }

    calculateDistance(lat1, lon1, lat2, lon2) {

        var radlat1 = Math.PI * lat1 / 180;
        var radlat2 = Math.PI * lat2 / 180;
        var radlon1 = Math.PI * lon1 / 180;
        var radlon2 = Math.PI * lon2 / 180;
        var theta = lon1 - lon2;
        var radtheta = Math.PI * theta / 180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;

        return dist;
    }

    accordion_click() {

        $('.js-accordion__toggle').unbind("click");
        $('.js-accordion__toggle').on("click", function (e) {

            e.preventDefault();

            var $content = $(this).parents(".js-accordion").find(".js-accordion__content");

            if ($(this).hasClass("is-on")) {
                $(this).removeClass("is-on");
                $content.removeClass("is-on");
                //gaHelper.trackEvent("Accordion", "Close", $(this).text(), null, true);
            } else {
                $(this).addClass("is-on");
                $content.addClass("is-on");
                //gaHelper.trackEvent("Accordion", "Open", $(this).text(), null, true);
            }
        });


        $('.js-accordion--reverse__toggle').on("click", function (e) {

            e.preventDefault();

            var $content = $(this).parents(".js-accordion--reverse").find(".js-accordion--reverse__content");
            var $contentMini = $(this).parents(".js-accordion--reverse").find(".js-accordion--reverse__content--minimised");

            if ($(this).hasClass("is-on")) {
                $(this).removeClass("is-on");
                $contentMini.removeClass("is-on");
                $content.removeClass("is-on");
                //gaHelper.trackEvent("Mancester Banner Close", "Close", $(this).text(), null, true);
            } else {
                $(this).addClass("is-on");
                $contentMini.addClass("is-on");
                $content.addClass("is-on");
                //gaHelper.trackEvent("Mancester Banner Open", "Open", $(this).text(), null, true);
            }
        });
    }

    resultsInSpireGpStyle(componentipc, locations) {

        let that = this;

        //locations = that.filterLocationsForSpireGP(locations);

        if (locations.length > 0) {
            locations = locations.slice(0, 3);

            // using componentipc find the template associated

            let source = $(componentipc).find("#location-template").html(),
                template,
                context,
                html;

            if (source) {
                template = Handlebars.compile(source);
                context = { locations: locations };
                $(componentipc).find(".js-location-accordions").remove();
                html = template(context);

                $(componentipc).find("#location-template").after(html);

                that.accordion_click();
            }
        }
    }

    resultsStandardStyleWithOneStopeBreastFilter(componentipc, locations, hasBreastClinicSetup, show) {

        let that = this;

        //if (hasBreastClinicSetup == "1") {
        //    locations = that.filterOneStopBreastClinic(locations);
        //}

        if (locations.length > 0) {
            that.totalRecords = locations.length;
            $(componentipc).find(".js-finder__hospital-treatment--item").remove();

            let trimmedList = locations.slice(0, show);

            if (that.showAll) {
                trimmedList = locations;
            }

            let source = $(componentipc).find("#location-template").html(),
                template,
                context,
                html;

            if (source) {
                template = Handlebars.compile(source);
                context = { locations: trimmedList };
                html = template(context);

                $(componentipc).find("#location-template").after(html);
            }
        }

        if (show > 6 || show == -1) {
            $(componentipc).find(".js-finder__hospital-treatment--show-more-bar").hide();
        }
        else {
            $(componentipc).find(".js-finder__hospital-treatment--show-more-bar").show();
        }

    }

    resultsInHeroStyle(componentipc, locations) {

        let that = this;

        $(componentipc).find(".js-finder__hospital-treatment--item").remove();

        if (locations.length > 0) {
            locations = locations.slice(0, 3);

            let lt = $(componentipc).find("#location-template");
            
            let source = lt.html(),
                template,
                context,
                html;

            if (source) {
                template = Handlebars.compile(source);
                context = { locations: locations };
                html = template(context);

                lt.after(html);
            }
        }
    }

    callMethod(method, userLatLong, allowScroll, componentipc, show) {

        let dataUrl = apilocation + method;

        $("#globalSpinner").show();

        let that = this;

        if (allowScroll == undefined) {
            allowScroll = true;
        }

        let hasSpireGpSetup = $(componentipc).find("#SpireGPModule").val(); 
        let hasBreastClinicSetup = $(componentipc).find("#BreastClinicEnabled").val();
        let useHeroSetup = $(componentipc).find("#LocationSearchHero").val();

        $.ajax({
            url: dataUrl,
            async: true,
            dataType: 'json',
            success: function (json) {

                let locations = json;

                locations = that.sortLocationsByDistance(locations, userLatLong);

                if(useHeroSetup === "1") {
                    that.resultsInHeroStyle(componentipc, locations);
                } else if (hasSpireGpSetup === "1") {
                    that.resultsInSpireGpStyle(componentipc, locations);
                }
                else {
                    that.resultsStandardStyleWithOneStopeBreastFilter(componentipc, locations, hasBreastClinicSetup, show);
                }

                $("#globalSpinner").hide();

            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                $("#globalSpinner").hide();
            }
        });
    }

}

// Function to execute a script only once.
(function ($) {
    $.getScriptOnce = function (url, successhandler) {
        if ($.getScriptOnce.loaded.indexOf(url) === -1) {
            $.getScriptOnce.loaded.push(url);
            if (successhandler === undefined) {
                return $.getScript(url);
            } else {
                return $.getScript(url, function (script, textStatus, jqXHR) {
                    successhandler(script, textStatus, jqXHR);
                });
            }
        } else {
            return false;
        }

    };

    $.getScriptOnce.loaded = [];

}(jQuery));